







































import Vue from "vue";
import Component from "vue-class-component";
import {Prop, Emit, Ref} from "vue-property-decorator";
import {useDocumentsStore} from "@/store/documents";

const ALLOWED_TYPES = [
  "image/jpeg",
  "image/png",
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
];

const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB

@Component
export default class DocumentUpload extends Vue {
  @Prop({type: Number, required: true})
  public readonly deviceId!: number;

  @Ref("fileInput")
  public readonly fileInput!: HTMLInputElement;

  public isDragOver = false;
  public isUploading = false;
  public error: string | null = null;

  public triggerFileInput(): void {
    if (!this.isUploading) {
      this.fileInput.click();
    }
  }

  public onDragOver(): void {
    this.isDragOver = true;
  }

  public onDragLeave(): void {
    this.isDragOver = false;
  }

  public onDrop(event: DragEvent): void {
    this.isDragOver = false;
    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.uploadFile(files[0]);
    }
  }

  public onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const files = input.files;
    if (files && files.length > 0) {
      this.uploadFile(files[0]);
    }
    input.value = "";
  }

  @Emit("uploaded")
  public emitUploaded(): void {
    return;
  }

  private async uploadFile(file: File): Promise<void> {
    this.error = null;

    if (!ALLOWED_TYPES.includes(file.type)) {
      this.error = "Ungültiger Dateityp. Erlaubt sind: JPG, PNG, PDF, DOC, DOCX.";
      return;
    }

    if (file.size > MAX_FILE_SIZE) {
      this.error = "Die Datei ist zu groß. Maximale Größe: 10 MB.";
      return;
    }

    this.isUploading = true;

    try {
      const documentsStore = useDocumentsStore();
      const result = await documentsStore.uploadDocument(this.deviceId, file);

      if (result.success) {
        this.emitUploaded();
      } else {
        this.error = result.message || "Fehler beim Hochladen.";
      }
    } catch (e) {
      this.error = "Fehler beim Hochladen der Datei.";
      console.error(e);
    } finally {
      this.isUploading = false;
    }
  }
}
